Application.Branding = {
    ready: function () {

        this.Frame.ready();
        this.Loading.ready();
        this.LinkedinCoverUploadLoading.ready();
        this.LinkedinPictureLoading.ready();
        this.LinkedinPictureUploadLoading.ready();
        this.Cover.ready(this.LinkedinCoverTransformer);
        this.Output.ready();
        this.LinkedinCoverTransformer.ready();
        this.LinkedinPictureTransformer.ready();

    }
}